import React, {createContext, useContext, useState} from "react";
import PharmacyService from "../../services/PharmacyService";
import {UserContext} from "../UserContextProvider";

export const PMSPharmacyContext = createContext("PMSPharmacyContext");

const PMSPharmacyContextProvider = ({children}) => {

    const p = JSON.parse(localStorage.getItem("selectedPharmacy"));

    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [selectedPharmacy, setSelectedPharmacy] = useState(p ? p : null);

    const userContext = useContext(UserContext);

    const addSelectedPharmacy = (data) => {
        try {
            setLoading(true);
            setErrorMsg('');
            localStorage.setItem("selectedPharmacy", JSON.stringify(data));
            setSelectedPharmacy(data);
            setLoading(false);
            return true;
        } catch (e) {
            setLoading(false);
            console.log(e);
            return false;
        }
    }

    const removeSession = async () => {
        try {
            await PharmacyService.removeSession();
            return true;
        } catch (error) {
            console.log("removeSession error", error);
            return false;
        }
    }

    return (
        <PMSPharmacyContext.Provider
            value={{
                loading,
                errorMsg,
                selectedPharmacy,
                addSelectedPharmacy,
                setSelectedPharmacy,
                removeSession
            }}
        >
            {children}
        </PMSPharmacyContext.Provider>
    )
}

export default PMSPharmacyContextProvider;